import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft, Ghost } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CustomCursor from "../components/CustomCursor";

const NotFound = () => {
  return (
    <div className="bg-[var(--ink)] text-[var(--cream)] min-h-screen flex flex-col">
      {/* <CustomCursor /> */}
      <Navbar />
      <div className="grain" />

      <main className="flex-1 flex items-center justify-center relative overflow-hidden pt-20">
        {/* Cinematic Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[var(--gold)]/5 rounded-full blur-[120px] animate-pulse" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[var(--gold)]/3 rounded-full blur-[150px] animate-pulse" style={{ animationDelay: "1s" }} />
        </div>

        <div className="container-xl px-6 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <div className="relative inline-block mb-12">
              <span className="font-display italic text-[15vw] md:text-[10vw] leading-none opacity-10 select-none">404</span>
              <motion.div
                animate={{ y: [0, -20, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute inset-0 flex items-center justify-center"
              >
                <Ghost size={80} className="text-[var(--gold)] opacity-50" />
              </motion.div>
            </div>

            <h1 className="font-display text-4xl md:text-6xl mb-6">Lost in the <span className="italic gold-text">Void.</span></h1>
            <p className="max-w-xl mx-auto text-[var(--cream-muted)] text-lg md:text-xl font-body mb-12 leading-relaxed">
              The story you're looking for hasn't been written yet, or it's been moved to a different timeline.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6">
              <Link to="/" className="btn-primary group">
                <Home size={18} className="mr-2" />
                Back to Safety
              </Link>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
